import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-[91px]" }

import { CardTitle } from '@/components/ui/card';
    import { Separator } from '@/components/ui/separator';
    import { columns } from '@/tables/columns/payrolls';
    import { computed } from 'vue';
    import { handleQueryRetry } from '@/utils/helpers';
    import { Head } from '@inertiajs/vue3';
    // Removed custom button and export override in favor of reusing the shared export component
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreatePayroll from '@/components/salary/CreatePayroll.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PayrollStatusSelect from '@/components/salary/PayrollStatusSelect.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem } from '@/types';
    import { ref, watch } from 'vue';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'Payrolls',
  setup(__props) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const selectedStatus = ref('open');
    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'payrolls.payroll_header',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.PAYROLLS, selectedCompanyId, selectedStatus],
        queryFn: getPayrolls,
        retry: handleQueryRetry,
    });

    async function getPayrolls() {
        const { data } = await axios.get(
            route('v2.salary.payrolls.table', {
                companyId: selectedCompanyId.value,
                filter: selectedStatus.value,
            }),
        );
        return data.data;
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('dashboards.employee.payroll_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).PAYROLLS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "enable-export": true,
              "default-column-visibility": {
                    id: false,
                },
              "default-sorting": [
                    {
                        id: 'year',
                        desc: true,
                    },
                    {
                        id: 'month',
                        desc: true,
                    },
                ]
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('payrolls.payroll_header')), 1)
                  ]),
                  _: 1
                })
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "payrolls" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(PayrollStatusSelect, {
                        modelValue: selectedStatus.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStatus).value = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_unref(Separator), {
                      orientation: "vertical",
                      class: "h-2.5!"
                    }),
                    (_unref(hasPermission)(_unref(Permission).SALARY_PAYROLLS_CREATE))
                      ? (_openBlock(), _createBlock(CreatePayroll, {
                          key: 0,
                          "selected-company-id": selectedCompanyId.value
                        }, null, 8, ["selected-company-id"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})